var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitfeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-3cy68l",
    "aria-label": "pen-write",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.3812 4.61828V4.61828C18.2096 5.44721 18.2096 6.7906 17.3812 7.61953L7.39008 17.6107C7.13368 17.8671 6.81244 18.049 6.46069 18.1369L2.99625 19.0033L3.86261 15.5388C3.95056 15.1871 4.13245 14.8658 4.38883 14.6094L14.381 4.61828C15.2096 3.79 16.5527 3.79 17.3812 4.61828Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5015 9.4993L12.5002 6.49805"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0037 18.0024L19.9093 19.0969C18.7006 20.3053 16.7412 20.3053 15.5325 19.0969V19.0969C14.3223 17.8911 12.3648 17.8911 11.1546 19.0969"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitfeedback);
export default __webpack_public_path__ + "static/media/submitfeedback.4c3a4a1aacc225ef28d2a4cd0b6883ed.svg";
export { ForwardRef as ReactComponent };